import { Item } from "../../../models/Items/Item";
import * as Yup from "yup";
import { sortByKey } from "../../../utils/helpers";

  export const FIELD_NAMES = {
    certiType: "certiType",
    certiNote: "certiNote",
    height: "height",
    width: "width",
    extension: "extension",
    baseDepth: "baseDepth",
    baseHeight: "baseHeight",
    baseLength: "baseLength",
    baseWidth: "baseWidth",
    canopyDepth: "canopyDepth",
    canopyLength: "canopyLength",
    canopyShape: "canopyShape",
    backplateDepth: "backplateDepth",
    backplateHeight: "backplateHeight",
    backplateLength: "backplateLength",
    backplateShape: "backplateShape",
    backplateWidth: "backplateWidth",
    fixture_Height: "fixture_Height",
    height_min: "height_min",
    jBox: "jBox",
    oaHeight: "oaHeight",
    rpm: "rpm",
    bulbWattage: "bulbWattage",
    cableLength: "cableLength",
    capacitorValue: "capacitorValue",
    carton1DimensionalWeight: "carton1DimensionalWeight",
    carton2DimensionalWeight: "carton2DimensionalWeight",
    cartonCount: "cartonCount",
    cfmAverage: "cfmAverage",
    cfmHigh: "cfmHigh",
    cfmLow: "cfmLow",
    style: "style",
    romanticSize: "romanticSize",
    designGrouping: "designGrouping",
    stockcode: "stockcode",
    longDesc: "longDesc",
    pdFamilyName: "pdFamilyName",
    shortDesc: "shortDesc",
    // familyName: "familyName",
    seriesName: "seriesName",
    category: "category",
    function: "function",
    baseCode: "baseCode",
    shortDescPrv: "shortDescPrv",
    pdCode: "pdCode",
    stage: "stage",
    status: "status",
    stockcodePrv: "stockcodePrv",
    basecodePrv: "basecodePrv",
    relatives: "relatives",
    department: "department",
    introdate: "introdate",
    pdStockcode: "pdStockcode",
    marketingDesigner: "marketingDesigner",
    groupName: "groupName",
    brandCollection: "brandCollection",
    socketQty: "socketQty",
    socketType: "socketType",
    socket1Type: "socket1Type",
    socket2Type: "socket2Type",
    socket3Type: "socket3Type",
    socketDtl: "socketDtl",
    bulbShape: "bulbShape",
    lightSource: "lightSource",
    lightQty: "lightQty",
    ledType: "ledType",
    ledDriverType: "ledDriverType",
    ledDimmingType: "ledDimmingType",
    ledColorTemp: "ledColorTemp",
    ledLumens: "ledLumens",
    assembly: "assembly",
    assemblyDetail: "assemblyDetail",
    priMtrlManufMethod: "priMtrlManufMethod",
    secMtrlManufMethod: "secMtrlManufMethod",
    thirdMtrlManufMethod: "thirdMtrlManufMethod",
    fourACDesc: "fourACDesc",
    primaryMaterial: "primaryMaterial",
    secondaryMaterial: "secondaryMaterial",
    treatmentType: "treatmentType",
    treatment: "treatment",
    thirdMaterial: "thirdMaterial",
    skuType: "skuType",
    packaging: "packaging",
    shadeDesc: "shadeDesc",
    wiringDtl: "wiringDtl",
    candleTube: "candleTube",
    candleTubeDiameter: "candleTubeDiameter",
    candleTubeFinish: "candleTubeFinish",
    candleTubeHeight: "candleTubeHeight",
    candleTubeShape: "candleTubeShape",
    harpFinish: "harpFinish",
    harpType: "harpType",
    riser: "riser",
    finialFinish: "finialFinish",
    finialHeight: "finialHeight",
    finialMaterial: "finialMaterial",
    finialShape: "finialShape",
    finialWidth: "finialWidth",
    hardwareFinish: "hardwareFinish",
    hardwareMaterial: "hardwareMaterial",
    rod_Count: "rod_Count",
    rod_Diameter: "rod_Diameter",
    break_count: "break_count",
    break_length: "break_length",
    rod_Shape: "rod_Shape",
    knobType: "knobType",
    finialFinishCd: "finialFinishCd",
    chainLink: "chainLink",
    chain: "chain",
    baseMaterial: "baseMaterial",
    baseFinishCd: "baseFinishCd",
    factoryItemNum: "factoryItemNum",
    factShadeGlassCode: "factShadeGlassCode",
    htsMaterial: "htsMaterial",
    htsMaterialDtl: "htsMaterialDtl",
    subContVendor1: "subContVendor1",
    subContVendor1FactoryItem: "subContVendor1FactoryItem",
    subContVendor2: "subContVendor2",
    subContVendor2FactoryItem: "subContVendor2FactoryItem",
    subContVendor3: "subContVendor3",
    subContVendor3FactoryItem: "subContVendor3FactoryItem",
    subContVendor4: "subContVendor4",
    subContVendor4FactoryItem: "subContVendor4FactoryItem",
    subContVendor5: "subContVendor5",
    subContVendor5FactoryItem: "subContVendor5FactoryItem",
    targetWholesalePrice: "targetWholesalePrice",
    targetIMAP: "targetIMAP",
    primaryFinishId: "primaryFinishId",
    secondaryFinishId: "secondaryFinishId",
    thirdFinishDesc: "thirdFinishDesc",
    baseFinishDesc: "baseFinishDesc",
    bC_DesignerSeq: "bC_DesignerSeq",
    bC_CategorySeq: "bC_CategorySeq",
    bomSearch: "bomSearch",
    dataGridView: "dataGridView",
    sellingLineInStockDate: "sellingLineInStockDate",
    slIntroDate: "slIntroDate",
    isSLIntroDateTBD: "isSLIntroDateTBD",
    bomType: "bomType",
    reqDate: "reqDate",
    agreedSampleReadyDate: "agreedSampleReadyDate",
    numberOfDaysRequestedForSample: "numberOfDaysRequestedForSample",
    rod1Length: "rod1Length",
    rod2Length: "rod2Length",
    rod3Length: "rod3Length",
    shadeSlant: "shadeSlant",
    cordCoverBreakLength: "cordCoverBreakLength",
    cordCoverBreakWidth: "cordCoverBreakWidth",
    couplingLength: "couplingLength",
    couplingWidth: "couplingWidth",
    ledBoardWattage: "ledBoardWattage",
    itemStockingType: "itemStockingType",
    developmentType: "developmentType",
    itemVendorCost: "itemVendorCost",
    itemStatus: "itemStatus",
    cordColor: "cordColor",
    canBeInverted: "canBeInverted",
    bladeFinish1: "bladeFinish1",
    bladeFinish2: "bladeFinish2",
    bulbIncluded: "bulbIncluded",
    notes: "notes",
    leadtimeLevel: "leadtimeLevel",
    sampleQty: "sampleQty",
    vendorLeadTime: "vendorLeadTime",
    vendorMOQ: "vendorMOQ",
    wattsHigh: "wattsHigh",
    standardEstimatedYearlyEnergyCost: "standardEstimatedYearlyEnergyCost",
    slNetWeight: "slNetWeight",
    shadeQty: "shadeQty",
    rod1Qty: "rod1Qty",
    rod2Qty: "rod2Qty",
    rod3Qty: "rod3Qty",
    qtyFabricGlassShades: "qtyFabricGlassShades",
    packQty: "packQty",
    numberOfBlades: "numberOfBlades",
    numberOfSockets: "numberOfSockets",
    mountingHoleQty: "mountingHoleQty",
    mpCube: "mpCube",
    mpHeight: "mpHeight",
    mpLength: "mpLength",
    mpWidth: "mpWidth",
    mpWeight: "mpWeight",
    bulbBeamSpread: "bulbBeamSpread",
    bulbDimmingRangeMax: "bulbDimmingRangeMax",
    bulbDimmingRangeMin: "bulbDimmingRangeMin",
    chainLink1Height: "chainLink1Height",
    chainLink2Height: "chainLink2Height",
    chainLink2Width: "chainLink2Width",
    cordCoverQty: "cordCoverQty",
    fanDiameter: "fanDiameter",
    hoursLifeOnHighPower: "hoursLifeOnHighPower",
    hoursLifeOnLowPower: "hoursLifeOnLowPower",
    hoursLifeOnMedPower: "hoursLifeOnMedPower",
    ipCube: "ipCube",
    ipWidth: "ipWidth",
    lampSKUNetWeight: "lampSKUNetWeight",
    shelfDays: "shelfDays",
    orderMulti: "orderMulti",
    contentPercent: "contentPercent",
  }

  // Fields that should not be copied when creating a new product from an existing one
  // Extend this list as needed when more non-copyable fields are identified
  export const COPY_EXCLUDED_FIELDS: Array<keyof Item | string> = [
    // "id",
    FIELD_NAMES.stockcode,
    FIELD_NAMES.pdStockcode,
  ];

  export const MULTI_SELECT_FIELD_NAMES = {
    stage: "stages",
    status: "statuses",
    marketingDesigner: "marketingDesigners",
    function: "functions",
    slIntroDate: "slIntroDates",
    pdFamily: "pdFamilies",
    seriesName: "seriesNames",
    vendor: "vendors",
    developmentType: "developmentTypes",
    tags: "tags",
  };
  
  // the values in below object properties must be same as the value of field property of api/PickList/data-fields-types-list response
  // This is used to filter and find appropriate types based on field value for displaying as dropdown on edit item page
  export const dataFieldNames = {
    certiNote: "CertiNote",
    baseShape: "BaseShape",
    batteryType: "BatteryType",
    brandCollection: "BrandCollection",
    bulbShape: "BulbShape",
    bulbShapeCode: "BulbShapeCode",
    canopyShape: "CanopyShape",
    category: "Category",
    colorTemperature: "ColorTemperature",
    cri: "CRI",
    department: "Department",
    ledDimmingType: "LEDDimmingType",
    driverLocation: "DriverLocation",
    ledDriverType: "LEDDriverType",
    ledType: "LEDType",
    lightSource: "LightSource",
    locationRating: "LocationRating",
    mountingType: "MountingType",
    reportingBrand: "ReportingBrand",
    socketType: "SocketType",
    socket1Type: "Socket1Type",
    socket2Type: "Socket2Type",
    socket3Type: "Socket3Type",
    wireColor: "WireColor",
    jBox: "JBox",
    ledColorTemp: "LED Color Temperature",
    packaging: "Packaging",
    riser: "Riser",
    knobType: "KnobType",
    chainLink: "Chain Link",
    certiType: "CertiType",
    sKURank: "SKURank",
    vendorMOQType: "VendorMOQType",
    itemStockingType: "StockingType",
    warehouse: "Warehouse",
    sLStatus: "SLStatus",
    developmentType: "DevelopmentType",
    romanticSize: "RomanticSize",
    prop65: "prop65",
    etlControlNumber: "ETLControlNumber",
    ukcaCertification: "UKCACertification",
    ukcaCertificationNumber: "UKCACertificationNumber",
    customerAssemblyDetail: "CustomerAssemblyDetail",
    estimatedTimeRequiredForAssembly: "EstimatedTimeRequiredForAssembly",
    patentStatus: "PatentStatus",
    suggestedNumberOfPeopleRequiredForInstall: "SuggestedNumberOfPeopleRequiredForInstall",
    toolsRequired: "ToolsRequired",
    warrantyYears: "WarrantyYears",
    lightKitIncluded: "LightKitIncluded",
    masterFinish: "MasterFinish",
    motorType: "MotorType",
    relativeStyle: "RelativeStyle",
    slopeCeiling: "SlopeCeiling",
    specialAssembly: "SpecialAssembly",
    swiveling: "Swiveling",
    countryOfOrigin: "CountryOfOrigin",
    itemRoyaltyCode: "ItemRoyaltyCode",
    batteryLocation: "BatteryLocation",
    batteryQty: "BatteryQty",
    bulbBase: "BulbBase",
    bulbColorTemp: "BulbColorTemp",
    bulbCri: "BulbCri",
    bulbIncandescentEquivalentWattage: "BulbIncandescentEquivalentWattage",
    bulbLumen: "BulbLumen",
    bulbVoltage: "BulbVoltage",
    chargeTime: "ChargeTime",
    dimmer: "Dimmer",
    ledClass: "LedClass",
    lumensOnHighPower: "LumensOnHighPower",
    lumensOnLowPower: "LumensOnLowPower",
    lumensOnMedPower: "LumensOnMedPower",
    recBulbBothRequired: "RECBulbBothRequired",
    voltageInput: "VoltageInput",
    voltageOutput: "VoltageOutput",
    fssPrimaryMaterial: "FSSPrimaryMaterial",
    fssSecondaryMaterial: "FSSSecondaryMaterial",
    fssThirdMaterial: "FSSThirdMaterial",
    recommendedRoom1: "RecommendedRoom1",
    diffuser1FactoryFinishCode: "Diffuser1FactoryFinishCode",
    diffuser1Finish: "Diffuser1Finish",
    diffuser1Material: "Diffuser1Material",
    diffuser2FactoryFinishCode: "Diffuser2FactoryFinishCode",
    diffuser2Finish: "Diffuser2Finish",
    diffuser2Material: "Diffuser2Material",
    finishCode: "FinishCode",
    finishDescription: "FinishDescription",
    treatmentMaterial: "TreatmentMaterial",
    ipFreightClass: "IPFreightClass",
    ipUpsable: "IPUPSable",
    mpUpsable: "MPUpsable",
    chainRodFinish: "ChainRodFinish",
    connectionType: "ConnectionType",
    glass: "Glass",
    productType: "ProductType",
    websites: "Websites",
    reverseSwitchLocation: "ReverseSwitchLocation",
    shadeCode: "ShadeCode",
    shadeFinishingType: "ShadeFinishingType",
    shadeOuterMaterial: "ShadeOuterMaterial",
    shadeTreatment: "ShadeTreatment",
    socketFinishFactoryCode: "SocketFinishFactoryCode",
    socketHousingFinish: "SocketHousingFinish",
    socketHousingMaterial: "SocketHousingMaterial",
    productTrim: "ProductTrim",
    itemClass: "ItemClass",
    class: "Class",
    relativeTrend: "RelativeTrend",
    seriesName: "SeriesName",
    brand: "Brand",
    buyerNumber: "BuyerNumber",
    color: "Color",
    division: "Division",
    engineeringGroup: "EngineeringGroup",
    inventoryStrategy: "InventoryStrategy",
    itemFlashMessage: "ItemFlashMessage",
    itemPoolCode: "ItemPoolCode",
    lampingCode: "LampingCode",
    ledRoyalty: "LEDRoyalty",
    plannerNumber: "PlannerNumber",
    prepackedBanded: "PrepackedBanded",
    purchasingABC: "PurchasingABC",
    quickShipItem: "QuickShipItem",
    relatedUnitofMeasure: "RelatedUnitofMeasure",
    shippingMethod: "ShippingMethod",
    unitofMeasure: "UnitofMeasure",
    yearCode: "YearCode",
    numberOfTiers: "NumberOfTiers",
    designGrouping: "DesignGrouping",
    treatmentType: "TreatmentType",
    treatment: "Treatment",
    bulbIncluded: "BulbIncluded",
    cordColor: "CordColor",
    canBeInverted: "YesNoNATBD",
    compatibleLightKit: "CompatibleLightKit",
    family: "Family",
    shippingConditionsCode: "ShippingConditionsCode",
    applyCommissions: "ApplyCommissions",
    longItem: "LongItem",
    itemBranchPreference: "ItemBranchPreference",
    warehouseProcessGroup: "WarehouseProcessGroup",
    itemPublicationStatus: "ItemPublicationStatus",
    importDetails: "ImportDetails",
    layerSourceCode: "LayerSourceCode",
    collectionPricing: "CollectionPricing",
    manufacturerTransmitterItemNumber: "ManufacturerTransmitterItemNumber",
    manufacturerReceiverItemNumber: "ManufacturerReceiverItemNumber",
    downrodType: "DownrodType",
  }

export const attachmentLevels = {
  BC: "BC",
  SC: "SC"
}

export const initialValues: Item = {
  stockcode: "",
  longDesc: "",
  shortDesc: "",
  stage: null,
  status: null,
  pdFamilyName: "",
  // familyName: "",
  category: null,
  style: null,
  function: null,
  skuType: null,
  assembly: "",
  factoryItemNum: null,
  shadeDesc: "",
  primaryMaterial: null,
  secondaryMaterial: null,
  factShadeGlassCode: "",
  height: null,
  width: null,
  socketQty: null,
  socketType: null,
  socket1Type: null,
  socket2Type: null,
  socket3Type: null,
  socketDtl: "",
  wiringDtl: "",
  shortDescPrv: "",
  hardwareMaterial: null,
  pdCode: "",
  sampleQty: null,
  stockcodePrv: "",
  basecodePrv: "",
  fixture_Height: null,
  height_min: null,
  bulbShape: null,
  certiType: "",
  certiTypeDisplayText: "",
  jBox: "",
  jBoxDisplayText: "",
  oaHeight: null,
  rpm: null,
  treatmentType: null,
  treatment: null,
  treatmentTypeDisplayText: "",
  treatmentDisplayText: "",
  rod_Count: null,
  rod_Diameter: "",
  break_count: null,
  break_length: "",
  rod_Shape: "",
  title20: null,
  department: null,
  introdate: null,
  htsMaterial: "",
  htsMaterialDtl: "",
  priMtrlManufMethod: "",
  secMtrlManufMethod: "",
  thirdMtrlManufMethod: "",
  thirdMaterial: null,
  testing: null,
  marketingDesigner: null,
  lightSource: null,
  ledType: null,
  ledDriverType: null,
  ledDimmingType: null,
  ledLumens: "",
  ledColorTemp: "",
  knobType: "",
  knobTypeDisplayText: "",
  finialFinishCd: "",
  baseMaterial: null,
  baseMaterialDisplayText: "",
  subContVendor1: "",
  subContVendor1FactoryItem: "",
  subContVendor2: "",
  subContVendor2FactoryItem: "",
  subContVendor3: "",
  subContVendor3FactoryItem: "",
  subContVendor4: "",
  subContVendor4FactoryItem: "",
  subContVendor5: "",
  subContVendor5FactoryItem: "",
  groupName: "",
  romanticSize: null,
  romanticSizeDisplayText: "",
  fourACDesc: "",
  designGrouping: null,
  designGroupingDisplayText: "",
  brandCollection: null,
  canopyShape: null,
  candleTubeHeight: null,
  finialMaterial: "",
  bC_DesignerSeq: null,
  bC_CategorySeq: null,
  changeBaseCodeForAllProducts: null,
  certiNote: null,
  certiNoteDisplayText: "",
  baseShape: null,
  baseShapeDisplayText: "",
  batteryType: null,
  batteryTypeDisplayText: "",
  bulbShapeDisplayText: "",
  bulbShapeCode: null,
  bulbShapeCodeDisplayText: "",
  canopyShapeDisplayText: "",
  categoryDisplayText: "",
  colorTemperature: null,
  colorTemperatureDisplayText: "",
  cri: null,
  criDisplayText: "",
  departmentDisplayText: "",
  ledDimmingTypeDisplayText: "",
  driverLocation: null,
  driverLocationDisplayText: "",
  ledDriverTypeDisplayText: "",
  ledTypeDisplayText: "",
  lightSourceDisplayText: "",
  locationRating: null,
  locationRatingDisplayText: "",
  mountingType: null,
  mountingTypeDisplayText: "",
  reportingBrand: null,
  reportingBrandDisplayText: "",
  // socketType: null,
  socketTypeDisplayText: "",
  socket1TypeDisplayText: "",
  socket2TypeDisplayText: "",
  socket3TypeDisplayText: "",
  wireColor: null,
  wireColorDisplayText: "",
  // New string fields
  allThreadType: "",
  assemblyDetail: "",
  backplateShape: "",
  baseCode: "",
  basecodeDescription: "",
  binning: "",
  bladeFinish1: null,
  bladeFinish2: null,
  bladeFinish1DisplayText: "",
  bladeFinish2DisplayText: "",
  bulbInBox1: "",
  bulbWattage: null,
  candleTubeFinish: "",
  cbCertificationNumber: "",
  cccCertificationNumber: "",
  ceCertificationNumber: "",
  chainLength: "",
  compatibleLightKit: [],
  copyFreeForm: "",
  cordColor: null,
  cordColorDisplayText: "",
  cordCoverLength: "",
  cordCoverTotalLength: "",
  cordLength: "",
  couplingWidth: null,
  criticalToQuality: "",
  depth: "",
  driverDimensions: "",
  eacCertificateNumber: "",
  emcCertificationNumber: "",
  energyStarCertificationNumber: "",
  etlCertificationNumber: "",
  extension: "",
  factoryFinishCode: "",
  fcCertificationNumber: "",
  feature1: "",
  feature2: "",
  feature3: "",
  canBeInverted: null,
  canBeInvertedDisplayText: "",
  fieldModify: null,
  hangStraight: null,
  finialFinish: "",
  hardwareFinish: "",
  harpFinish: "",
  harpType: "",
  icCertificationNumber: "",
  lampshadeType: "",
  maxRotation: "",
  maxSlopeCeiling: null,
  mountingProcedure: "",
  notesWeb: "",
  packaging: "",
  patentNumber: "",
  pdStockcode: "",
  itemClass: null,
  itemClassDisplayText: null,
  profileRomanceCopy: "",
  prop65: null,
  prop65DisplayText: "",
  recBulb1Hyperlink: "",
  recBulb1ManufactureID: "",
  recBulb1Name: "",
  recBulb2Hyperlink: "",
  recBulb2ManufactureID: "",
  recBulb2Name: "",
  relativeTrend: null,
  relativeTrendDisplayText: null,
  remoteType: "",
  riser: "",
  rod1Length: null,
  rod2Length: null,
  rod3Length: null,
  seriesDescription: "",
  seriesName: null,
  seriesNameDisplayText: "",
  shadeExteriorMaterial: "",
  shadeFitterType: "",
  shadeInteriorMaterial: "",
  shadeShape: "",
  shadeSlant: "",
  standardCare: "",
  stockCode: "",
  switchDetails: "",
  switchLocation: "",
  tagFinishDescription: "",
  transformerType: "",
  treatmentTypeInterior: "",
  vendor: null,
  vendorDisplayText: "",
  averageBulbLife: null,
  backplateDepth: null,
  backplateHeight: null,
  backplateLength: null,
  backplateWidth: null,
  baseDepth: null,
  baseHeight: null,
  baseLength: null,
  baseWidth: null,
  bladePitch: null,
  bladeToCeilingMaxHeight: null,
  bladeToCeilingMinHeight: null,
  bulbBeamSpread: null,
  bulbDimmingRangeMax: null,
  bulbDimmingRangeMin: null,
  cableLength: null,
  candleTubeDiameter: null,
  candleTubeShape: null,
  canopyDepth: null,
  canopyLength: null,
  canopyShade: null,
  capacitorValue: null,
  carton1DimensionalWeight: null,
  carton1Height: null,
  carton1Length: null,
  carton1Weight: null,
  carton1Width: null,
  carton2DimensionalWeight: null,
  carton2Height: null,
  carton2Length: null,
  carton2Weight: null,
  carton2Width: null,
  carton3Height: null,
  carton3Length: null,
  carton3Weight: null,
  carton3Width: null,
  cartonCount: null,
  cfmAverage: null,
  cfmHigh: null,
  cfmLow: null,
  cfmWattageHigh: null,
  cfmWattageLow: null,
  chainLink1Height: null,
  chainLink1Thickness: null,
  chainLink1Width: null,
  chainLink2Height: null,
  chainLink2Thickness: null,
  chainLink2Width: null,
  class: null,
  classDisplayText: null,
  cordCoverBreakLength: null,
  cordCoverBreakWidth: null,
  cordCoverQty: null,
  couplingLength: null,
  cutoutSize: null,
  deliveredLumens: null,
  diameter: null,
  dnPrice: null,
  efficacy: null,
  fanDiameter: null,
  finialHeight: null,
  finialShape: null,
  finialWidth: null,
  heightFromCenterOfJbox: null,
  heightWithoutTail: null,
  hoursLifeOnHighPower: null,
  hoursLifeOnLowPower: null,
  hoursLifeOnMedPower: null,
  imap: null,
  installableHeight1: null,
  installableHeight2: null,
  installableHeight3: null,
  installableHeight4: null,
  installableHeight5: null,
  ipCube: null,
  ipHeight: null,
  ipLength: null,
  ipWeight: null,
  ipWidth: null,
  lampSKUNetWeight: null,
  ledBoardLumen: null,
  ledBoardWattage: null,
  length: null,
  lightQty: null,
  maxDegree: null,
  maxWattage: null,
  maximumHeight: null,
  minimumCustomHeight: null,
  minimumHeight: null,
  motorSize: "",
  mountingHoleQty: null,
  mpCube: null,
  mpHeight: null,
  mpLength: null,
  mpWidth: null,
  mpWeight: null,
  numberOfBlades: null,
  numberOfSockets: null,
  packQty: null,
  qtyFabricGlassShades: null,
  rod1Qty: null,
  rod2Qty: null,
  rod3Qty: null,
  rodTotalQty: null,
  shadeBottomDepth: null,
  shadeBottomWidth: null,
  shadeHeight: null,
  shadeQty: null,
  shadeTopDepth: null,
  shadeTopWidth: null,
  slNetWeight: null,
  standardEnergyUseWave: null,
  standardEstimatedYearlyEnergyCost: null,
  standardWeightedAverageAirflow: null,
  itemVendorCost: null,
  wattsHigh: null,
  wattsLow: null,
  wattsMedium: null,
  widthMax: null,
  widthMin: null,
  wireLength: null,
  iS_220V: null,
  iS_220VNotAvailable: null,
  ada: null,
  adjustable: null,
  adjustableArm: null,
  articulatingShadeHead: null,
  assembledInTheUSA: null,
  assembleRequired: null,
  bulbIncluded: null,
  bulbIncludedDisplayText: "",
  cannotShipToCalifornia: null,
  cannotShipToCanada: null,
  cccCertification: null,
  convertible: null,
  convertibleKitRequired: null,
  darkSky: null,
  diffuser: null,
  dwpIncluded: null,
  emcCertification: null,
  energyStar: null,
  euCertification: null,
  extendable: null,
  fcCertification: null,
  fwcCompliant: null,
  globalAssortmentAvailable: null,
  hasCordCover: null,
  hasFanMount: null,
  icCertification: null,
  indicatorLight: null,
  ipRating: null,
  lightKitAdaptable: null,
  madeInTheUSA: null,
  madeToOrder: null,
  motionSensorIncluded: null,
  mountWallCeiling: null,
  mountingPlate: null,
  photocellIncluded: null,
  pivotable: null,
  preLacedChain: null,
  remoteIncluded: null,
  replaceableLamp: null,
  rod1Cuttable: null,
  rod1Removeable: null,
  rod2Cuttable: null,
  rod2Removeable: null,
  rod3Cuttable: null,
  rod3Removeable: null,
  shipByTruck: null,
  smartEnabled: null,
  title24: null,
  voltageConvertible: null,
  warmColorDimming: null,
  sellingLineInStockDate: null,
  isSLIntroDateTBD: false,
  bomType: null,
  commission: null,
  skuRank: null,
  skuRankDisplayText: "",
  bcRank: null,
  bcRankDisplayText: "",
  inventoryItem: null,
  sellingItem: null,
  purchasingItem: null,
  etlCertification: null,
  warehouse: null,
  warehouseDisplayText: "",
  vendorMOQ: null,
  vendorMOQType: null,
  vendorMOQTypeDisplayText: "",
  vendorLeadTime: null,
  slStatus: null,
  slStatusDisplayText: "",
  agreedSampleReadyDate: null,
  numberOfDaysRequestedForSample: null,
  reqDate: null,
  targetIMAP: null,
  targetWholesalePrice: null,
  drawingNum: "",
  itemStockingType: null,
  itemStockingTypeDisplayText: "",
  targetFOB: null,
  sampleNotes: "",
  notes: "",
  canopyHeight: null,
  canopyWidth: null,
  bulbInBox2: "",
  transformerMount: "",
  reverseSwitch: null,
  factoryPrimaryFinish: "",
  factorySecondaryFinish: "",
  factoryThirdFinish: "",
  primaryFinish: null,
  primaryFinishCode: "",
  primaryFinishName: "",
  secondaryFinish: null,
  secondaryFinishCode: "",
  secondaryFinishName: "",
  thirdFinish: null,
  thirdFinishCode: "",
  thirdFinishName: "",
  developmentType: null,
  developmentTypeDisplayText: "",
  mfgSocketDetail: "",
  driverPartNumber: "",
  ledPartNumber: "",
  primaryMaterialDisplayText: "",
  secondaryMaterialDisplayText: "",
  thirdMaterialDisplayText: "",
  royaltyDesigner: null,
  royaltyDesignerDisplayText: "",
  royalty: null,
  itemStatus: null,
  etlControlNumber: null,
  etlControlNumberDisplayText: "",
  ukcaCertification: null,
  ukcaCertificationNumber: null,
  ukcaCertificationNumberDisplayText: "",
  customerAssemblyDetail: null,
  customerAssemblyDetailDisplayText: "",
  estimatedTimeRequiredForAssembly: null,
  estimatedTimeRequiredForAssemblyDisplayText: "",
  patentStatus: null,
  patentStatusDisplayText: "",
  suggestedNumberOfPeopleRequiredForInstall: null,
  suggestedNumberOfPeopleRequiredForInstallDisplayText: "",
  toolsRequired: null,
  toolsRequiredDisplayText: "",
  warrantyYears: null,
  warrantyYearsDisplayText: "",
  lightKitIncluded: null,
  lightKitIncludedDisplayText: "",
  masterFinish: null,
  masterFinishDisplayText: "",
  motorType: null,
  motorTypeDisplayText: "",
  relativeStyle: null,
  relativeStyleDisplayText: "",
  slopeCeiling: null,
  slopeCeilingDisplayText: "",
  specialAssembly: null,
  specialAssemblyDisplayText: "",
  swiveling: null,
  swivelingDisplayText: "",
  countryOfOrigin: null,
  countryOfOriginDisplayText: "",
  itemRoyaltyCode: null,
  itemRoyaltyCodeDisplayText: "",
  batteryLocation: null,
  batteryLocationDisplayText: "",
  batteryQty: null,
  batteryQtyDisplayText: "",
  bulbBase: null,
  bulbBaseDisplayText: "",
  bulbColorTemp: null,
  bulbColorTempDisplayText: "",
  bulbCri: null,
  bulbCriDisplayText: "",
  bulbIncandescentEquivalentWattage: null,
  bulbIncandescentEquivalentWattageDisplayText: "",
  bulbLumen: null,
  bulbLumenDisplayText: "",
  bulbVoltage: null,
  bulbVoltageDisplayText: "",
  chargeTime: null,
  chargeTimeDisplayText: "",
  dimmer: null,
  dimmerDisplayText: "",
  ledClass: null,
  ledClassDisplayText: "",
  lumensOnHighPower: null,
  lumensOnHighPowerDisplayText: "",
  lumensOnLowPower: null,
  lumensOnLowPowerDisplayText: "",
  lumensOnMedPower: null,
  lumensOnMedPowerDisplayText: "",
  recBulbBothRequired: null,
  recBulbBothRequiredDisplayText: "",
  voltageInput: null,
  voltageInputDisplayText: "",
  voltageOutput: null,
  voltageOutputDisplayText: "",
  fssPrimaryMaterial: null,
  fssPrimaryMaterialDisplayText: "",
  fssSecondaryMaterial: null,
  fssSecondaryMaterialDisplayText: "",
  fssThirdMaterial: null,
  fssThirdMaterialDisplayText: "",
  recommendedRoom1: null,
  recommendedRoom1DisplayText: "",
  diffuser1FactoryFinishCode: null,
  diffuser1FactoryFinishCodeDisplayText: "",
  diffuser1Finish: null,
  diffuser1FinishDisplayText: "",
  diffuser1Material: null,
  diffuser1MaterialDisplayText: "",
  diffuser2FactoryFinishCode: null,
  diffuser2FactoryFinishCodeDisplayText: "",
  diffuser2Finish: null,
  diffuser2FinishDisplayText: "",
  diffuser2Material: null,
  diffuser2MaterialDisplayText: "",
  finishCode: null,
  finishCodeDisplayText: "",
  finishDescription: null,
  finishDescriptionDisplayText: "",
  treatmentMaterial: null,
  treatmentMaterialDisplayText: "",
  ipFreightClass: null,
  ipFreightClassDisplayText: "",
  ipUpsable: null,
  ipUpsableDisplayText: "",
  mpUpsable: null,
  mpUpsableDisplayText: "",
  chainRodFinish: null,
  chainRodFinishDisplayText: "",
  connectionType: null,
  connectionTypeDisplayText: "",
  glass: null,
  glassDisplayText: "",
  productType: null,
  productTypeDisplayText: "",
  websites: null,
  websitesDisplayText: "",
  reverseSwitchLocation: null,
  reverseSwitchLocationDisplayText: "",
  shadeCode: null,
  shadeCodeDisplayText: "",
  shadeFinishingType: null,
  shadeFinishingTypeDisplayText: "",
  shadeOuterMaterial: null,
  shadeOuterMaterialDisplayText: "",
  shadeTreatment: null,
  shadeTreatmentDisplayText: "",
  socketFinishFactoryCode: null,
  socketFinishFactoryCodeDisplayText: "",
  socketHousingFinish: null,
  socketHousingFinishDisplayText: "",
  socketHousingMaterial: null,
  socketHousingMaterialDisplayText: "",
  productTrim: null,
  productTrimDisplayText: "",
  brand: null,
  brandDisplayText: null,
  buyerNumber: null,
  buyerNumberDisplayText: null,
  color: null,
  colorDisplayText: null,
  conversionFactor: null,
  conversionFactorDisplayText: null,
  shortDesc2: null,
  shortDesc2DisplayText: null,
  division: null,
  divisionDisplayText: null,
  engineeringGroup: null,
  engineeringGroupDisplayText: null,
  harmonizedShipCode: null,
  harmonizedShipCodeDisplayText: null,
  inventoryStrategy: null,
  inventoryStrategyDisplayText: null,
  itemFlashMessage: null,
  itemFlashMessageDisplayText: null,
  itemPoolCode: null,
  itemPoolCodeDisplayText: null,
  lampingCode: null,
  lampingCodeDisplayText: null,
  leadTimeLevel: null,
  leadTimeLevelDisplayText: null,
  ledRoyalty: null,
  ledRoyaltyDisplayText: null,
  plannerNumber: null,
  plannerNumberDisplayText: null,
  prepackedBanded: null,
  prepackedBandedDisplayText: null,
  purchasingABC: null,
  purchasingABCDisplayText: null,
  quickShipItem: null,
  quickShipItemDisplayText: null,
  relatedUnitofMeasure: null,
  relatedUnitofMeasureDisplayText: null,
  searchText: null,
  searchTextDisplayText: null,
  shippingMethod: null,
  shippingMethodDisplayText: null,
  unitofMeasure: null,
  unitofMeasureDisplayText: null,
  yearCode: null,
  yearCodeDisplayText: null,
  numberOfTiers: null,
  numberOfTiersDisplayText: null,
  family: null,
  familyDisplayText: null,
  shippingConditionsCode: null,
  shippingConditionsCodeDisplayText: null,
  applyCommissions: null,
  applyCommissionsDisplayText: null,
  longItem: null,
  longItemDisplayText: null,
  itemBranchPreference: null,
  itemBranchPreferenceDisplayText: null,
  warehouseProcessGroup: null,
  warehouseProcessGroupDisplayText: null,
  itemPublicationStatus: null,
  itemPublicationStatusDisplayText: null,
  importDetails: null,
  importDetailsDisplayText: null,
  layerSourceCode: null,
  layerSourceCodeDisplayText: null,
  collectionPricing: null,
  collectionPricingDisplayText: null,
  shelfDays: null,
  orderMulti: null,
  contentPercent: null,
  manufacturerTransmitterItemNumber: null,
  manufacturerReceiverItemNumber: null,
  downrodType: null,
}

//Mapping of dropdown fields to their appropriate sort keys
export const DROPDOWN_SORT_KEYS: Record<string, string> = {
  productFunctions: "description",
  stageStatusTags: "description",
  attachmentTypes: "attachType",
  bomTypes: "bomDescription"
};

// These fields stores the reference id and not the actual value e.g. Brand, Category
export const REFERENCE_FIELDS_FOR_EDIT_PRODUCT = [
  "certiNote",
  "baseShape",
  "batteryType",
  "bulbShape",
  "bulbShapeCode",
  "canopyShape",
  "category",
  "colorTemperature",
  "cri",
  "department",
  "ledDimmingType",
  "driverLocation",
  "ledDriverType",
  "ledType",
  "lightSource",
  "locationRating",
  "mountingType",
  "reportingBrand",
  "socketType",
  "socket1Type",
  "socket2Type",
  "socket3Type",
  "wireColor",
  "stage",
  "status",
  "royaltyDesigner",
  "marketingDesigner",
  "category",
  "function",
  "brandCollection",
  "style",
  "skuType",
  "bomType",
  "slStatus",
  "skuRank",
  "bcRank",
  "warehouse",
  "vendorMOQType",
  "itemStockingType",
  "primaryFinish",
  "secondaryFinish",
  "thirdFinish",
  "developmentType",
  "primaryMaterial",
  "secondaryMaterial",
  "thirdMaterial",
  "romanticSize",
  "vendor",
  "prop65",
  "itemStatus",
  "baseMaterial",
  "etlControlNumber",
  "ukcaCertification",
  "ukcaCertificationNumber",
  "customerAssemblyDetail",
  "estimatedTimeRequiredForAssembly",
  "patentStatus",
  "suggestedNumberOfPeopleRequiredForInstall",
  "toolsRequired",
  "warrantyYears",
  "lightKitIncluded",
  "masterFinish",
  "motorType",
  "relativeStyle",
  "slopeCeiling",
  "specialAssembly",
  "swiveling",
  "countryOfOrigin",
  "itemRoyaltyCode",
  "batteryLocation",
  "batteryQty",
  "bulbBase",
  "bulbColorTemp",
  "bulbCri",
  "bulbIncandescentEquivalentWattage",
  "bulbLumen",
  "bulbVoltage",
  "chargeTime",
  "dimmer",
  "ledClass",
  "lumensOnHighPower",
  "lumensOnLowPower",
  "lumensOnMedPower",
  "recBulbBothRequired",
  "voltageInput",
  "voltageOutput",
  "fssPrimaryMaterial",
  "fssSecondaryMaterial",
  "fssThirdMaterial",
  "recommendedRoom1",
  "diffuser1FactoryFinishCode",
  "diffuser1Finish",
  "diffuser1Material",
  "diffuser2FactoryFinishCode",
  "diffuser2Finish",
  "diffuser2Material",
  "finishCode",
  "finishDescription",
  "treatmentMaterial",
  "ipFreightClass",
  "ipUpsable",
  "mpUpsable",
  "chainRodFinish",
  "connectionType",
  "glass",
  "productType",
  "websites",
  "reverseSwitchLocation",
  "shadeCode",
  "shadeFinishingType",
  "shadeOuterMaterial",
  "shadeTreatment",
  "socketFinishFactoryCode",
  "socketHousingFinish",
  "socketHousingMaterial",
  "productTrim",
  "itemClass",
  "class",
  "relativeTrend",
  "seriesName",
  "brand",
  "buyerNumber",
  "color",
  "division",
  "engineeringGroup",
  "inventoryStrategy",
  "itemFlashMessage",
  "itemPoolCode",
  "lampingCode",
  "ledRoyalty",
  "plannerNumber",
  "prepackedBanded",
  "purchasingABC",
  "quickShipItem",
  "relatedUnitofMeasure",
  "shippingMethod",
  "unitofMeasure",
  "yearCode",
  "numberOfTiers",
  "designGrouping",
  "treatmentType",
  "treatment",
  "bladeFinish1",
  "bladeFinish2",
  "bulbIncluded",
  "cordColor",
  "canBeInverted",
  "family",
  "shippingConditionsCode",
  "applyCommissions",
  "longItem",
  "itemBranchPreference",
  "warehouseProcessGroup",
  "itemPublicationStatus",
  "importDetails",
  "layerSourceCode",
  "collectionPricing",
  "manufacturerTransmitterItemNumber",
  "manufacturerReceiverItemNumber",
  "downrodType",
  "certiType",
  "jBox",
  "knobType",
];

export const VALIDATION_MESSAGE_TEXT = {
  characters: "characters",
  digitsNumber: "digits number"
}

export const checkMaxLengthValidation = (maxLength: number, messageText: string) => {
  return Yup.string()
    .trim()
    .nullable()
    .max(maxLength, `Must be at most ${maxLength} ${messageText}`)
};

export const checkDecimalNumberValidation = (maxDigits: number = 10, maxDecimalPlaces: number = 2) => {
  const decimalRegex = maxDecimalPlaces === 2 ? /^\d{1,8}(?:\.\d{0,2})?$/ : /^\d{1,8}(?:\.\d{0,3})?$/;
  return Yup.string()
    .trim()
    .nullable()
    .matches(decimalRegex, `Must be at most ${maxDigits} digits with ${maxDecimalPlaces} decimal places`)
};

export const checkIntegerNumberValidation = (maxDigits: number = null) => {
  const integerRegex = maxDigits !== null ? new RegExp(`^\\d{1,${maxDigits}}$`) : /^\d+$/;
  return Yup.string()
    .trim()
    .nullable()
    .matches(integerRegex, 
      maxDigits !== null 
        ? `Must be a whole number with up to ${maxDigits} digits (decimal values are not allowed)` 
        : `Must be a whole number (decimal values are not allowed)`
    );
};

export const validations = Yup.object().shape({
  brandCollection: Yup.string().trim().nullable().required("Brand Collection is required"),
  developmentType: Yup.string().trim().nullable().required("Development Type is required"),
  shortDesc: Yup.string()
    .trim()
    .required("Short Description is required")
    .min(1, "Short Description must be at least 1 characters")
    .max(200, "Short Description must be at most 200 characters"),
  height: checkDecimalNumberValidation(),
  width: checkDecimalNumberValidation(),
  baseDepth: checkDecimalNumberValidation(),
  baseHeight: checkDecimalNumberValidation(),
  baseLength: checkDecimalNumberValidation(),
  baseWidth: checkDecimalNumberValidation(),
  canopyDepth: checkDecimalNumberValidation(),
  canopyLength: checkDecimalNumberValidation(),
  backplateDepth: checkDecimalNumberValidation(),
  backplateHeight: checkDecimalNumberValidation(),
  backplateLength: checkDecimalNumberValidation(),
  backplateShape: checkMaxLengthValidation(100, VALIDATION_MESSAGE_TEXT.characters),
  backplateWidth: checkDecimalNumberValidation(),
  fixture_Height: checkDecimalNumberValidation(),
  height_min: checkDecimalNumberValidation(),
  rod1Length: checkDecimalNumberValidation(),
  rod2Length: checkDecimalNumberValidation(),
  rod3Length: checkDecimalNumberValidation(),
  shadeSlant: checkDecimalNumberValidation(),
  oaHeight: checkDecimalNumberValidation(),
  rpm: checkIntegerNumberValidation(),
  bulbWattage: checkIntegerNumberValidation(),
  cableLength: checkIntegerNumberValidation(),
  capacitorValue: checkIntegerNumberValidation(),
  cartonCount: checkIntegerNumberValidation(),
  cfmAverage: checkIntegerNumberValidation(),
  cfmHigh: checkIntegerNumberValidation(),
  cfmLow: checkIntegerNumberValidation(),
  stockcode: checkMaxLengthValidation(50, VALIDATION_MESSAGE_TEXT.characters),
  longDesc: checkMaxLengthValidation(200, VALIDATION_MESSAGE_TEXT.characters),
  pdFamilyName: checkMaxLengthValidation(50, VALIDATION_MESSAGE_TEXT.characters),
  baseCode: checkMaxLengthValidation(30, VALIDATION_MESSAGE_TEXT.characters),
  shortDescPrv: checkMaxLengthValidation(200, VALIDATION_MESSAGE_TEXT.characters),
  pdCode: checkMaxLengthValidation(50, VALIDATION_MESSAGE_TEXT.characters),
  stockcodePrv: checkMaxLengthValidation(100, VALIDATION_MESSAGE_TEXT.characters),
  basecodePrv: checkMaxLengthValidation(50, VALIDATION_MESSAGE_TEXT.characters),
  pdStockcode: checkMaxLengthValidation(100, VALIDATION_MESSAGE_TEXT.characters),
  groupName: checkMaxLengthValidation(200, VALIDATION_MESSAGE_TEXT.characters),
  socketQty: checkIntegerNumberValidation(),
  socketDtl: checkMaxLengthValidation(100, VALIDATION_MESSAGE_TEXT.characters),
  lightQty: checkIntegerNumberValidation(),
  ledLumens: checkMaxLengthValidation(20, VALIDATION_MESSAGE_TEXT.characters),
  assembly: checkMaxLengthValidation(50, VALIDATION_MESSAGE_TEXT.characters),
  assemblyDetail: checkMaxLengthValidation(150, VALIDATION_MESSAGE_TEXT.characters),
  fourACDesc: checkMaxLengthValidation(1000, VALIDATION_MESSAGE_TEXT.characters),
  shadeDesc: checkMaxLengthValidation(200, VALIDATION_MESSAGE_TEXT.characters),
  wiringDtl: checkMaxLengthValidation(100, VALIDATION_MESSAGE_TEXT.characters),
  candleTubeDiameter: checkDecimalNumberValidation(),
  candleTubeFinish: checkMaxLengthValidation(200, VALIDATION_MESSAGE_TEXT.characters),
  candleTubeHeight: checkDecimalNumberValidation(),
  harpFinish: checkMaxLengthValidation(100, VALIDATION_MESSAGE_TEXT.characters),
  harpType: checkMaxLengthValidation(100, VALIDATION_MESSAGE_TEXT.characters),
  riser: checkMaxLengthValidation(100, VALIDATION_MESSAGE_TEXT.characters),
  finialFinish: checkMaxLengthValidation(100, VALIDATION_MESSAGE_TEXT.characters),
  finialHeight: checkDecimalNumberValidation(),
  finialMaterial: checkMaxLengthValidation(100, VALIDATION_MESSAGE_TEXT.characters),
  finialWidth: checkDecimalNumberValidation(),
  rod_Count: checkIntegerNumberValidation(4),
  rod_Diameter: checkMaxLengthValidation(40, VALIDATION_MESSAGE_TEXT.characters),
  break_count: checkIntegerNumberValidation(4),
  break_length: checkMaxLengthValidation(40, VALIDATION_MESSAGE_TEXT.characters),
  rod_Shape: checkMaxLengthValidation(40, VALIDATION_MESSAGE_TEXT.characters),
  finialFinishCd: checkMaxLengthValidation(10, VALIDATION_MESSAGE_TEXT.characters),
  chain: checkMaxLengthValidation(50, VALIDATION_MESSAGE_TEXT.characters),
  factoryItemNum: checkMaxLengthValidation(100, VALIDATION_MESSAGE_TEXT.characters),
  factShadeGlassCode: checkMaxLengthValidation(50, VALIDATION_MESSAGE_TEXT.characters),
  subContVendor1FactoryItem: checkMaxLengthValidation(200, VALIDATION_MESSAGE_TEXT.characters),
  subContVendor2FactoryItem: checkMaxLengthValidation(200, VALIDATION_MESSAGE_TEXT.characters),
  subContVendor3FactoryItem: checkMaxLengthValidation(200, VALIDATION_MESSAGE_TEXT.characters),
  subContVendor4FactoryItem: checkMaxLengthValidation(200, VALIDATION_MESSAGE_TEXT.characters),
  subContVendor5FactoryItem: checkMaxLengthValidation(200, VALIDATION_MESSAGE_TEXT.characters),
  targetWholesalePrice: checkDecimalNumberValidation(),
  targetIMAP: checkDecimalNumberValidation(),
  cordCoverBreakLength: checkDecimalNumberValidation(7, 3),
  cordCoverBreakWidth: checkDecimalNumberValidation(7, 3),
  couplingLength: checkDecimalNumberValidation(7, 3),
  couplingWidth: checkDecimalNumberValidation(7, 3),
  ledBoardWattage: checkDecimalNumberValidation(7),
  itemVendorCost: checkDecimalNumberValidation(),
  notes: checkMaxLengthValidation(500, VALIDATION_MESSAGE_TEXT.characters),
  leadtimeLevel: checkIntegerNumberValidation(),
  sampleQty: checkIntegerNumberValidation(),
  vendorLeadTime: checkIntegerNumberValidation(),
  vendorMOQ: checkIntegerNumberValidation(),
  wattsHigh: checkIntegerNumberValidation(),
  standardEstimatedYearlyEnergyCost: checkIntegerNumberValidation(),
  slNetWeight: checkDecimalNumberValidation(),
  shadeQty: checkIntegerNumberValidation(),
  rod1Qty: checkIntegerNumberValidation(),
  rod2Qty: checkIntegerNumberValidation(),
  rod3Qty: checkIntegerNumberValidation(),
  qtyFabricGlassShades: checkIntegerNumberValidation(),
  packQty: checkIntegerNumberValidation(),
  numberOfBlades: checkIntegerNumberValidation(),
  numberOfSockets: checkIntegerNumberValidation(),
  mountingHoleQty: checkIntegerNumberValidation(),
  bulbBeamSpread: checkIntegerNumberValidation(),
  bulbDimmingRangeMax: checkIntegerNumberValidation(),
  bulbDimmingRangeMin: checkIntegerNumberValidation(),
  chainLink1Height: checkIntegerNumberValidation(),
  chainLink2Height: checkIntegerNumberValidation(),
  chainLink2Width: checkIntegerNumberValidation(),
  cordCoverQty: checkIntegerNumberValidation(),
  fanDiameter: checkIntegerNumberValidation(),
  hoursLifeOnHighPower: checkIntegerNumberValidation(),
  hoursLifeOnLowPower: checkIntegerNumberValidation(),
  hoursLifeOnMedPower: checkIntegerNumberValidation(),
  ipCube: checkDecimalNumberValidation(),
  lampSKUNetWeight: checkIntegerNumberValidation(),
  carton1DimensionalWeight: checkDecimalNumberValidation(),
  carton2DimensionalWeight: checkDecimalNumberValidation(),
  ipWidth: checkDecimalNumberValidation(),
  mpCube: checkDecimalNumberValidation(),
  mpHeight: checkDecimalNumberValidation(),
  mpLength: checkDecimalNumberValidation(),
  mpWidth: checkDecimalNumberValidation(),
  mpWeight: checkDecimalNumberValidation(),
  shelfDays: checkIntegerNumberValidation(),
  orderMulti: checkDecimalNumberValidation(),
  contentPercent: checkDecimalNumberValidation(),
});

// New validation schema to extend for Create Product screen
const extendedCreateProductValidations = Yup.object().shape({
  stage: Yup.string().trim().nullable().required("Stage is required"),
  category: Yup.string().trim().nullable().required("Category is required"),
  status: Yup.string().trim().nullable().required("Status is required"),
  function: Yup.string().trim().nullable().required("Function is required"),
});

// Combine the existing validations with the new create product schema validations
export const createProductValidations = validations.concat(extendedCreateProductValidations);

export const validExtensions = {
  tif: "tif",
  tiff: "tiff",
  jpg: "jpg",
  jpeg: "jpeg",
  png: "png",
  pdf: "pdf",
  doc: "doc",
  docx: "docx",
  zip: "zip",
  ai: "ai",
};

export const toolingValidExtensions = {
  xls: "xls",
  xlsx: "xlsx"
};

export const XLSX_MIME_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const attachmentsValidationMessages = {
  attachmentTypeToastError: "Please select attachment type for all new added attachment(s) !",
  stockCodeInputBoxError: "Stock code is required",
  baseCodeInputBoxError: "Base code is required",
  stockCodeToastError: "Stock code is required for adding StockCode level attachments",
  baseCodeToastError: "Base code is required for adding BaseCode level attachments"
};

export const USER_ASSIGNMENTS_VALIDATION_MESSAGES = {
  userError: "Please select user in Product Assignments",
  assignmentRoleError: "Please select project role in Product Assignments"
};

export const ACCORDIAN_NAME = {
  certification: "CERTIFICATION & COMPLIANCE",
  dimension: "DIMENSIONS",
  features: "FEATURES",
  item: "ITEM",
  lamping: "LAMPING",
  maufacturing: "MANUFACTURING DETAILS",
  marketing: "MARKETING",
  materialFinish: "MATERIAL/FINISH DETAILS",
  packagingWeights:"PACKAGING AND WEIGHTS",
  productDetails:"PRODUCT DETAILS",
  vendor: "VENDOR",
  bom:"BILL OF MATERIALS (BOM)"
}
export const THUMBNAIL_IMAGE_API_URL = `${process.env.REACT_APP_API_URL}/Attachment/thumb-image`;

// BILL OF MATERIALS category needed as it is not present in get layout fields api response
export const BILL_OF_MATERIALS_LAYOUT_CATEGORY = {
  categoryName: "BILL OF MATERIALS (BOM)",
  tabOrder: 1,
  fields: [
    {
      fieldName: "bomType",
      label: "BOM Type",
      tabOrder: 1
    },
    {
      fieldName: "bomSearch",
      label: "bomSearch",
      tabOrder: 1
    },
    {
      fieldName: "dataGridView",
      label: "dataGridView",
      tabOrder: 1
    }],
}

export const MANAGE_QUOTES_GRID = {
  categoryName: "MANAGE QUOTES",
  tabOrder: 1,
  fields: [
    {
      fieldName: "quotesDataGridView",
      label: "quotesDataGridView",
      tabOrder: 1
    }
  ],
}

export const MANAGE_CHECKLIST_GRID = {
  categoryName: "Stage CheckList",
  tabOrder: 1,
  fields: [
    {
      fieldName: "checklistManageView",
      label: "checklistManageView",
      tabOrder: 1
    }
  ],
}

export const PRICING_LAYOUT_CATEGORY = {
  categoryName: "Pricing",
  tabOrder: 1,
  fields: [
    {
      fieldName: "fobCost",
      label: "FOB Cost",
      tabOrder: 4
    },
    {
      fieldName: "quoteDate",
      label: "Quote Date",
      tabOrder: 2
    },
    {
      fieldName: "quoteNumber",
      label: "Quote Number",
      tabOrder: 1
    },
    {
      fieldName: "notes",
      label: "Notes",
      tabOrder: 3
    },
    {
      fieldName: "targetFOBCost",
      label: "Target FOB Cost",
      tabOrder: 5
    },
    {
      fieldName: "ipCube",
      label: "IP Cube",
      tabOrder: 7
    },
    {
      fieldName: "vendor",
      label: "Vendor",
      tabOrder: 8
    },
    {
      fieldName: "tariffPercent",
      label: "Tariff Percent",
      tabOrder: 6
    }, 
    {
      fieldName: "blankField",
      label: "Blank Field",
      tabOrder: 9
    },  
    {
      fieldName: "umapPrice",
      label: "UMAP Price",
      tabOrder: 13
    },
    // Calculation Read-Only Fields
    // {
    //   fieldName: "cubeMultiplier",
    //   label: "Cube Multiplier",
    //   tabOrder: 9
    // },
    {
      fieldName: "freightCost",
      label: "Freight Cost",
      tabOrder: 10
    },
    {
      fieldName: "landedCost",
      label: "Landed Cost",
      tabOrder: 11
    },
    {
      fieldName: "quoteApproved",
      label: "Quote Approved",
      tabOrder: 12
    },
    {
      fieldName: "dnPrice",
      label: "DN Price",
      tabOrder: 14
    },
    {
      fieldName: "grossGMPercent",
      label: "Gross GM Percent",
      tabOrder: 16
    },
    {
      fieldName: "netMargin",
      label: "Net Margin",
      tabOrder: 17
    },
    /* {
      fieldName: "blankField",
      label: "Blank Field",
      tabOrder: 12
    }, */
    {
      fieldName: "umapApproved",
      label: "UMAP Approved",
      tabOrder: 15
    },
    /* {
      fieldName: "commissionDollars",
      label: "Commission Dollars",
      tabOrder: 12
    },
    {
      fieldName: "commissionPercent",
      label: "Commission Percent",
      tabOrder: 13
    },
    {
      fieldName: "dnToUMAPMultiplier",
      label: "DN to UMAP Multiplier",
      tabOrder: 11
    },
    {
      fieldName: "dutyCost",
      label: "Duty Cost",
      tabOrder: 21
    },
    {
      fieldName: "grossGMDollars",
      label: "Gross GM Dollars",
      tabOrder: 20
    },
    {
      fieldName: "netMarginDollars",
      label: "Net Margin Dollars",
      tabOrder: 15
    },
    
    {
      fieldName: "percentOfFOB",
      label: "Percent of FOB",
      tabOrder: 15
    },
    {
      fieldName: "royaltyDollars",
      label: "Royalty Dollars",
      tabOrder: 16
    },
    {
      fieldName: "royaltyPercent",
      label: "Royalty Percent",
      tabOrder: 17
    },
    {
      fieldName: "tariffDollars",
      label: "Tariff Dollars",
      tabOrder: 19
    }, */
   
  ],
};

export const PRODUCT_BASIC_CATEGORY = {
  categoryName: "Product Basic",
  tabOrder: 1,
  fields: [
    {
      fieldName: "brandCollectionDisplayText",
      label: "Brand Collection",
      tabOrder: 1
    },
    {
      fieldName: "marketingDesignerDisplayText",
      label: "Marketing Designer",
      tabOrder: 2
    },
    {
      fieldName: "royaltyDesignerDisplayText",
      label: "Royalty Designer",
      tabOrder: 3
    },
    {
      fieldName: "categoryDisplayText",
      label: "Category",
      tabOrder: 4
    },
    {
      fieldName: "htsMaterial",
      label: "HTS Material",
      tabOrder: 5
    },
    {
      fieldName: "htsMaterialDtl",
      label: "HTS Material Detail",
      tabOrder: 6
    },
    {
      fieldName: "countryOfOriginDisplayText",
      label: "Country Of Origin",
      tabOrder: 7
    },
    {
      fieldName: "shortDesc",
      label: "Short Description",
      tabOrder: 8
    },
    {
      fieldName: "longDesc",
      label: "Long Description",
      tabOrder: 9
    },
    {
      fieldName: "stockcode",
      label: "Stock Code",
      tabOrder: 10
    },
    {
      fieldName: "baseCode",
      label: "Base Code",
      tabOrder: 11
    },
  ]
};

export const TOOLING_LAYOUT_CATEGORY = {
  categoryName: "Tooling",
  tabOrder: 1,
  fields: [
    {
      fieldName: "carNumber",
      label: "CAR Number",
      tabOrder: 2
    },
    {
      fieldName: "processedDate",
      label: "Processed Date",
      tabOrder: 3
    },
    {
      fieldName: "toolingNumber",
      label: "Tooling Number",
      tabOrder: 1
    },
    {
      fieldName: "toolingOpened",
      label: "Tooling Opened",
      tabOrder: 4
    }],
};

export const FIELDS_WITH_DISPLAY_TEXT = {
  brandCollection: "brandCollectionDisplayText",
  marketingDesigner: "marketingDesignerDisplayText",
  royaltyDesigner: "royaltyDesignerDisplayText",
  category: "categoryDisplayText",
  countryOfOrigin: "countryOfOriginDisplayText",
  seriesName: "seriesNameDisplayText"
}

export const DEVELOPMENT_TYPE_DROPDOWN_OPTIONS = [
  { id: 1, name: "New Design" },
  { id: 2, name: "Family Extension" },
  { id: 3, name: "Finish Add" },
].sort(sortByKey());

export const MAX_SIZE_FOR_REGULAR_UPLOAD = 25 * 1024 * 1024; // 25 MB

export const FILE_UPLOAD_CHUNK_SIZE = 5 * 1024 * 1024; // 5 MB

export const BOM_COMPONENT_DEVELOPMENT_TYPE_DROPDOWN_OPTIONS = [
  { id: 4, name: "New Component" },
  { id: 5, name: "Existing Component" },
].sort(sortByKey());

// Below is used to hide dropdown options from Stocking Type field that is displayed in Create BOM component modal
export const STOCKING_TYPE_HIDDEN_OPTIONS_FOR_BOM_COMPONENT = {
  sellingLine: "Selling Line",
  purchasedRawMaterial: "Purchased inc. Raw Material"
}
export const NO_TAGS_OPTION = { id: 0, name: "No Tags" };

export const PROJECT_MANAGER_ASSIGNMENT = "Project Manager";

export const PRODUCT_TYPE_DROPDOWN_OPTIONS = [
  { id: 0, name: "All Products" },
  { id: 3, name: "New Components Only" },
  { id: 4, name: "Existing Components Only" },
  { id: 1, name: "Selling Line Items Only" },
].sort(sortByKey());

export const QUOTE_APPROVAL_TYPE_DROPDOWN_OPTIONS = [
  { id: 1, name: "Quote Approved" },
  { id: 2, name: "UMAP Approved" },
];

export const QUOTE_CALCULATION_FIELDS = [
  "fobCost",
  "ipCube",
  "tariffPercent",
  "umapPrice",
];

export const QUOTE_APPROVAL_FIELDS = {
  quoteApproved: "quoteApproved",
  umapApproved: "umapApproved",
};

export const QUOTE_FIELD_SYMBOLS = {
  netMargin: "%",
  commissionDollars: "$",
  commissionPercent: "%",
  dutyCost: "$",
  dnPrice: "$",
  itemVendorCost: "$",
  grossGMPercent: "%",
  grossGMDollars: "$",
  percentOfFOB: "%",
  royaltyPercent: "%",
  royaltyDollars: "$",
  freightCost: "$",
  landedCost: "$",
  netMarginDollars: "$",
  tariffDollars: "$",
  umapPrice: "$",
  fobCost: "$",
  tariffPercent: "%",
  vendorCost: "$",
};

export const HEX_COLORS = [
  "#454545", "#F44336", "#9C27B0", "#3F51B5", "#2196F3", "#4CAF50", "#FFEB3B", "#FF9800", "#795548", "#607D8B", 
  "#3E2723", "#C2185B", "#D32F2F", "#1976D2", "#388E3C", "#0288D1", "#7B1FA2", "#0097A7", "#D32F2F", "#E91E63", 
  "#9C27B0", "#FF5722", "#4CAF50", "#8BC34A", "#CDDC39", "#FFEB3B", "#FF9800", "#9E9D24", "#F57C00", "#C2185B", 
  "#F06292", "#E91E63", "#9C27B0", "#2196F3", "#00BCD4", "#CDDC39", "#FFEB3B", "#8BC34A", "#FF5722", "#FFC107", 
  "#795548", "#9E9D24", "#FF9800", "#607D8B", "#FF5722", "#673AB7", "#9C27B0", "#00BCD4", "#3F51B5", "#FFEB3B", 
  "#FF9800", "#607D8B", "#009688", "#7B1FA2", "#0288D1", "#8BC34A", "#FFEB3B", "#FF5722", "#FF9800", "#9C27B0", 
  "#607D8B", "#795548", "#9E9D24", "#F57C00", "#2196F3", "#4CAF50", "#3E2723", "#D32F2F", "#1976D2", "#9C27B0", 
  "#CDDC39", "#4CAF50", "#FF9800", "#E91E63", "#2196F3", "#009688", "#FF5722", "#8BC34A", "#FFEB3B", "#F44336", 
  "#3F51B5", "#4CAF50", "#FF9800", "#8BC34A", "#9C27B0", "#FF5722", "#0288D1", "#7B1FA2", "#FFEB3B", "#CDDC39", 
  "#FF9800", "#9E9D24", "#607D8B", "#009688", "#FFEB3B", "#F44336", "#795548", "#E91E63", "#2196F3", "#388E3C"
];
export const EXCLUDED_ENDPOINTS_FOR_PREVENTING_GLOBAL_LOADER = ["/attachment/add", "/attachment/upload-chunks", "/Item/dynamic-filters-dropdown"];

export const ITEM_STATUS_DROPDOWN_OPTIONS = [
  { id: 1, name: "Active" },
  { id: 2, name: "Released To Inriver" },
  { id: 3, name: "Archived Development" },
].sort(sortByKey());

export enum ITEM_STATUS_ENUM {
  Active = "Active",
  ReleasedToInriver = "ReleasedToInriver",
  ArchivedDevelopment = "ArchivedDevelopment"
};

export const ITEM_STATUS_OPTIONS = [
  {
    id: 1,
    name: "Active",
    value: ITEM_STATUS_ENUM.Active,
  },
  {
    id: 2,
    name: "Released To Inriver",
    value: ITEM_STATUS_ENUM.ReleasedToInriver,
  },
  {
    id: 3,
    name: "Archived Development",
    value: ITEM_STATUS_ENUM.ArchivedDevelopment,
  },
]

export const TOOLING_ATTACHMENT_LABEL = "Tooling Attachment";

export const VIEW_ATTACHMENTS = "View Attachments";

export const VIEW_STATUS_REPORTS = "Status Reports"; 

export const VIEW_TOOLINGS = "View Toolings";

export const VIEW_NOTIFICATION_LOGS = "View Notification Logs";

export const VIEW_INACTIVE_PRODUCTS = "Inactive Products";

export const VIEW_PRODUCT_ASSIGNMENT = "Product Assignment";

export const NO_ASSIGNMENTS_WARNING = "No assignments available for the selected Basecode.";

export const ASSIGNMENTS_FETCH_WARNING = "Unable to fetch related assignments";

export const EDIT_GRID_TOOLTIP = "Double click to start editing";

export const NO_VENDOR = "No Vendor";

export const NO_SL_INTRO_DATE = "No SL Intro Date";

export const SL_INTRO_DATE_TBD = "TBD";

export type NotificationLogDetail = {
  stockCode: string;
  baseCode: string;
  brandCollection: string;
  seriesName: string;
  designer: string;
  developmentType: string;
  notification: string;
  notificationDate: string;
  productId: number;
  id: number;
}